import {useState, useEffect} from 'react';

export interface ElapsedTime {
    display: string;
    minutes: number;
    seconds: number;
}

const compute = (startedAt: string | null): ElapsedTime => {
    if (!startedAt) return {display: '', minutes: 0, seconds: 0};
    const diff = Math.max(0, Math.floor((Date.now() - new Date(startedAt).getTime()) / 1000));
    const m = Math.floor(diff / 60);
    const s = diff % 60;
    return {display: `${m}:${s.toString().padStart(2, '0')}`, minutes: m, seconds: s};
};

/**
 * Partagé entre le web (ré-export `pages/housekeeping/helpers/useElapsedTime.ts`) et le chrono
 * de la fiche ménage mobile.
 *
 * Returns the elapsed time since `startedAt`, refreshed every second.
 */
export function useElapsedTime(startedAt: string | null): ElapsedTime {
    const [state, setState] = useState<ElapsedTime>(() => compute(startedAt));

    useEffect(() => {
        if (!startedAt) {
            setState({display: '', minutes: 0, seconds: 0});
            return;
        }
        setState(compute(startedAt));
        const id = setInterval(() => setState(compute(startedAt)), 1000);
        return () => clearInterval(id);
    }, [startedAt]);

    return state;
}
